<template>
    <header class="app-header">
        <div class="head-container">
            <div class="header-main">
                <div class="logo-box">
                    <router-link to="/">
                        <img :src="logoUrl" alt="logo" style="width: 160px;">
                    </router-link>
                </div>
                <ul class="nav-list">
                    <li class="nav-item"
                        :class="[{'active': $route.name === nav.name},{'has-sub':nav.items && nav.items.length>0}]"
                        v-for="(nav,index) in navList" :key="index">
                        <span @click="navClick(nav)">
                            <router-link :to="nav.url" class="nav-name">{{$t(nav.key)}}</router-link>
                        </span>
                        <ul v-if="nav.items && nav.items.length>0" class="sub-nav-list">
                            <li v-for="(item,subIndex) in nav.items" :key="subIndex" class="sub-nav-item"
                                @click="navClick(item)">
                                <a :href="item.link" target="_blank" v-if="item.link">{{$t(item.key)}}</a>
                                <router-link :to="item.url" v-else>{{$t(item.key)}}</router-link>
                            </li>
                        </ul>
                    </li>
<!--                    <div class="lang-line"></div>-->
                    <div class="language">
                        <div>
                            <span @click="changeLanguage('zh')">中文</span>
                        </div>
                        <div>
                            <span @click="changeLanguage('en')">EN</span>
                        </div>
                        <div>
                            <span @click="changeLanguage('de')">DE</span>
                        </div>
                    </div>
                    <!--<li class="nav-item">-->
                        <!--<div class="nav-name">-->
                            <!--&lt;!&ndash;<i class="iconfont iconguoji"></i>&ndash;&gt;-->
                            <!--&lt;!&ndash;{{languageType}}&ndash;&gt;-->
                        <!--</div>-->
                        <!--<ul class="sub-nav-list">-->
                            <!--<li class="sub-nav-item" @click="changeLanguage('zh')">-->
                                <!--中文-->
                            <!--</li>-->
                            <!--<li class="sub-nav-item" @click="changeLanguage('en')">-->
                                <!--English-->
                            <!--</li>-->
                            <!--<li class="sub-nav-item" @click="changeLanguage('de')">-->
                                <!--Deutsch-->
                            <!--</li>-->
                        <!--</ul>-->
                    <!--</li>-->
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
    import data from './config'
    export default {
        data() {
            return {
                languageType: data.languageType,
                logoUrl: data.logoUrl,
                navList: data.navList
            }
        },
        methods: {
            changeLanguage(key){
                // if(key=='de'){
                //     this.$Message.info('正在建设中');
                //     return
                // }
                this.$store.dispatch('base/changeLanguage', key);
            },
            navClick(item){
                // if (item.url == '') {
                //     this.$Message.info('正在建设中');
                // }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header-main {
        @include clearfix;
    }
    .head-container{
        width: 1280px;
        margin: auto;
    }
    .lang-line{
        display: inline-block;
        width: 1px;
        height: 24px;
        background-color: #fff;
        margin-top: 24px;
        margin-right: 5px;
    }
    .language{
        float: right;
        display: flex;
        height: $header-height;
        width: 150px;
        justify-content: space-evenly;
        color: #fff;
        >div{
            cursor: pointer;
            line-height: $header-height;
            &:hover{
                color: $primary-light-color;
                span{
                    background-color: rgba(128, 128, 128, 0.5);
                }
            }
            span{
                padding: 5px 10px;
                border-radius: 5px;
            }
        }
    }

    .app-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 999;
        height: $header-height;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .logo-box {
        float: left;
        a {
            display: inline-block;
            margin-top: 20px;
        }
    }

    .nav-list {
        float: right;
        .nav-item {
            float: left;
            position: relative;
            transition: all 0.3s;
            min-width: 90px;
            text-align: center;
            .nav-name {
                display: inline-block;
                line-height: $header-height;
                color: #fff;
                font-size: $font-size-large;
                font-weight: 500;
                letter-spacing: 1.25px;
                padding: 0 25px;
                transition: color 0.3s;
                cursor: pointer;
            }
            &:after {
                content: '';
                position: absolute;
                background-color: transparent;
                left: 0;
                right: 0;
                bottom: 0;
                height: 3px;
                transition: background-color 0.3s;
            }
            &.active,
            &:hover {
                .nav-name {
                    color: $primary-light-color;
                }
                &:after {
                    background-color: $primary-light-color;
                }
            }
            &:hover {
                background-color: rgba(0, 0, 0, 0.6);
                .sub-nav-list {
                    visibility: visible;
                    opacity: 1;
                }
            }
        }
    }

    .sub-nav-list {
        position: absolute;
        left: 0;
        right: 0;
        visibility: hidden;
        opacity: 0;
        background-color: rgba(0, 0, 0, 0.6);
        transition: all 0.3s;
        .sub-nav-item {
            background-color: rgba(0, 0, 0, 0.5);
            line-height: 40px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            a {
                display: block;
                color: #fff;
            }
            &:hover {
                background-color: rgba(128, 128, 128, 0.8);
            }
        }
    }
</style>

<style lang="scss">
    .page-layout{
        &.zh{
            .head-container{
                .language{
                    >div{
                        &:nth-child(1){
                            color: $primary-light-color;
                            span{
                                background-color: rgba(128, 128, 128, 0.5);
                            }
                        }
                    }

                }
            }
        }
        &.en{
            .head-container{
                .language{
                    >div{
                        &:nth-child(2){
                            color: $primary-light-color;
                            span{
                                background-color: rgba(128, 128, 128, 0.5);
                            }
                        }
                    }
                }
            }
        }
        &.de{
            .head-container{
                .language{
                    >div{
                        &:nth-child(3){
                            color: $primary-light-color;
                            span{
                                background-color: rgba(128, 128, 128, 0.5);
                            }
                        }
                    }
                }
            }
        }
    }
</style>
